import { createSubtitlesCustomMenu } from './create-subtitles-custom-menu'
import { getFontColorMenuItems } from './lib'

/**
 * Settings subtitles font color menu
 */
export const SettingsSubtitlesFontColorMenu = createSubtitlesCustomMenu(
  'SettingsSubtitlesFontColorMenu',
  'font_color',
  getFontColorMenuItems
)
